import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const STATUS_SERIES = [
  { key: "compliant", label: "Compliant", color: "#3DB77E" },
  { key: "nonCompliant", label: "Non-Compliant", color: "#F04438" },
  { key: "invited", label: "Invited", color: "#0E4E9A" },
  { key: "registered", label: "Self-Registered", color: "#84BFF3" },
  { key: "assigned", label: "Registered", color: "#5786CC" },
  { key: "closed", label: "Deactivated", color: "#FDB022" },
];

const getStatusValue = (entry, key) => {
  if (key === "nonCompliant") {
    return Number(entry?.nonCompliant || entry?.non_compliant || 0);
  }
  if (key === "closed") {
    return Number(entry?.closed || entry?.deactivated || 0);
  }
  if (key === "registered") {
    return Number(entry?.registered || entry?.self_registered || 0);
  }
  if (key === "assigned") {
    return Number(entry?.assigned || 0);
  }
  return Number(entry?.[key]) || 0;
};

const PieChart = ({ chartData }) => {
  const safeChartData = Array.isArray(chartData) ? chartData : [];
  const latestEntry =
    safeChartData.length > 0
      ? safeChartData[safeChartData.length - 1]
      : null;
  // const providerTypeMap = latestEntry?.byProviderType || {};

  // const baseLabels = Object.keys(providerTypeMap);
  // const values = baseLabels.map((key) => Number(providerTypeMap[key]) || 0);
  // const labels = baseLabels.map((key, idx) => `${key} ${values[idx] ?? 0}`);
  // const baseLabels = ["Compliant", "Non-Compliant", "Invited","Registered", "Closed"];
  const values = STATUS_SERIES.map((series) => getStatusValue(latestEntry, series.key));
  const baseLabels = STATUS_SERIES.map((series) => series.label);
  const labels = baseLabels.map((key, idx) => `${key} ${values[idx] ?? 0}`);
  const backgroundColors = STATUS_SERIES.map((series) => series.color);

  const hasData = values.some((val) => val > 0);
  const datasetValues = hasData ? values : [];

  const data = {
    labels: hasData ? labels : [],
    datasets: [
      {
        label: "Provider Types",
        data: datasetValues,
        backgroundColor: backgroundColors,
        hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 10,
          padding: 20,
          usePointStyle: true,
        },
      },
    },
    cutout: "60%",
  };

  // Custom plugin for center text
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;
      ctx.save();
      const total = data.datasets[0].data.reduce(
        (acc, value) => acc + Number(value),
        0
      );

      ctx.font = "bold 20px Arial";
      ctx.fillStyle = "#1D2939";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(`${total}`, width / 2, height / 2 - 10);

      ctx.font = "13px Arial";
      ctx.fillText("Total Providers", width / 2, height / 2 + 10);
      ctx.restore();
    },
  };

  return (
    <div className="card-body mt-3.5">
      {hasData ? (
        <Doughnut
          data={data}
          options={options}
          plugins={[centerTextPlugin]}
        />
      ) : (
        <div className="flex items-center justify-center h-64 text-gray-500 text-sm">
          No provider type data available
        </div>
      )}
    </div>
  );
};

export default PieChart;
